var React = require('react');
var ReactNative = require('react-native');
var ListView = require('./wrappers/ListView-wrapper');

var Animated = require('./wrappers/Animated')

var ReUpText = require('./ReUpText');

var {
  Image,
  TouchableHighlight,
  Text,
  View,
  StyleSheet,
} = ReactNative;

var Category = require("create-react-class")({

  getInitialState: function() {

    var getSectionData = function(dataBlob, sectionID) {
      return dataBlob[sectionID];
    };

    return {
      dataBlob: {},
      dataSource: new ListView.DataSource({
        getSectionData: getSectionData,
        rowHasChanged: (r1, r2) => r1 !== r2,
        sectionHeaderHasChanged: (s1, s2) => s1 !== s2,
      }).cloneWithRowsAndSections(this.generateRows()),
    };
  },

  renderSectionHeader: function(sectionData, sectionID) {
    return (
      <View style={styles.catListHeaderContainer}>
        <ReUpText appManager={this.props.appManager} style={styles.catListTitle}>
          Categories {sectionID}
        </ReUpText>
      </View>
    );
  },

  render: function() {
    return (
      <ListView
        contentContainerStyle={styles.list}
        dataSource={this.state.dataSource}
        renderRow={this.renderRow}
        renderSectionHeader={this.renderSectionHeader}
      />
    );
  },

  renderRow: function(rowData: string, sectionID: number, rowID: number) {
    return (
      <TouchableHighlight underlayColor='rgba(0,0,0,0)'>
        <View>
          <View style={styles.row}>
            <ReUpText appManager={this.props.appManager} style={styles.text}>
              {rowData}
            </ReUpText>
          </View>
        </View>
      </TouchableHighlight>
    );
  },

  generateRows: function(): Array<string> {
    var dataBlob = [];
    for (var ii = 0; ii < 50; ii++) {
      dataBlob.push('Cell ' + ii);
    }
    return [dataBlob, dataBlob];
  },

});

var styles = StyleSheet.create({
  list: {
  },
  row: {
    padding: 12,
    backgroundColor: '#F6F6F6',
    borderColor: '#eee',
    borderBottomWidth: 1,
  },
  text: {
  },
  catListTitle: {
    fontWeight: 'bold',
    color: '#ffffff',
  },
  catListHeaderContainer: {
    padding: 12,
    backgroundColor: '#1F2036',
  }
});

module.exports = Category;
